export const getPlainTextLength = (html: string) => {
  if (!html) return 0;
  return html
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"').length;
};

export const getIconUrl = (icon?: string): string => {
  let iconUrl = "";
  const iconStr = icon?.trim() || "";

  if (
    iconStr &&
    iconStr !== "undefined" &&
    iconStr !== "null" &&
    iconStr !== "[object Object]"
  ) {
    if (
      iconStr.startsWith("data:") ||
      iconStr.startsWith("http") ||
      iconStr.startsWith("blob:")
    ) {
      iconUrl = iconStr;
    } else if (iconStr.startsWith("/9j/")) {
      iconUrl = `data:image/jpeg;base64,${iconStr}`;
    } else if (iconStr.startsWith("PHN2Zy") || iconStr.startsWith("PD94bW")) {
      iconUrl = `data:image/svg+xml;base64,${iconStr}`;
    } else if (iconStr.startsWith("iVBOR")) {
      iconUrl = `data:image/png;base64,${iconStr}`;
    } else if (iconStr.startsWith("AAABAA")) {
      iconUrl = `data:image/x-icon;base64,${iconStr}`;
    } else if (
      iconStr.startsWith("<svg") ||
      iconStr.startsWith("<?xml") ||
      iconStr.startsWith("<SVG")
    ) {
      iconUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(iconStr)}`;
    } else if (iconStr.startsWith("/") || iconStr.includes(".")) {
      iconUrl = iconStr;
    } else {
      iconUrl = `data:image/png;base64,${iconStr}`;
    }
  }

  return iconUrl;
};

export const base64ToDataUrl = (base64Image: string): string =>
  base64Image
    .replace(/^data:image\/[^;]+;base64,/, "")
    .replace(/^image\/[^;]+;base64,/, "");
